import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import SlidingPane from "react-sliding-pane";
import emailjs from "emailjs-com";
// import featuesTab1 from "./images/tab_1.png";
// import featuesTab2 from "./images/tab_2.png";
// import featuesTab3 from "./images/tab_3.png";
// import featuesTab4 from "./images/tab_4.png";
// import featuesTab5 from "./images/multisite support img.jpg";
// import oem from "./images/oem.png";
import "./Styles.css";
import "./Home.css";
// import Icons from "./Common/IconsGroup";

// // Who we help contents
// const HOME_HELP_CONTENT = [
//   {
//     // img: oem,
//     title: "OEM's",
//     info: "Build smart, connected compressors",
//     contents: [
//       "Ready-to-integrate IoT gateway.",
//       "Field data to R&D feedback.",
//       "Predictive diagnostics.",
//     ],
//   },
//   {
//     // img: oem,
//     title: "Service Providers",
//     info: "Enable data-driven service & AMC models",
//     contents: [
//       "Central fleet monitoring.",
//       "Automated service tickets.",
//       "Mobile field engineer apps.",
//     ],
//   },
//   {
//     // img: oem,
//     title: "End Users",
//     info: "Reduce energy & downtime with real-time insights",
//     contents: [
//       "Energy optimization.",
//       "Preventive alerts.",
//       "Multi-brand compatibility.",
//     ],
//   },
// ];

// Who we help contents
const HOME_PLATFORM_CONTENT = [
  {
    // img: oem,
    title: "Energy Intelligence",
    info: "Track and optimize compressor power (kW/CFM) in real time.",
  },
  {
    // img: oem,
    title: "Carbon Visibility",
    info: "Quantify your CO₂ emissions and prove your sustainability impact.",
  },
  {
    // img: oem,
    title: "Predictive Maintenance",
    info: "Move from reactive service to predictive reliability.",
  },
  {
    // img: oem,
    title: "Cloud-Connected",
    info: "Monitor across sites and brands with secure IoT connectivity.",
  },
];

const HOME_EMPOWER_CONTENT = [
  {
    // img: oem,
    title: "Fleet Management",
    info: "Monitor and manage entire compressor fleets with comprehensive health dashboards.",
  },
  {
    // img: oem,
    title: "New Revenue Streams",
    info: "Offer connected service programs and energy performance guarantees.",
  },
  {
    // img: oem,
    title: "Happier Customers",
    info: "Deliver proactive maintenance and predictive insights that prevent downtime.",
  },
];

// const FEATURES_TABS = [
//   { label: "Energy Optimization", value: "Tab1" },
//   { label: "Predictive Maintenance", value: "Tab2" },
//   { label: "Real-time Alerts", value: "Tab3" },
//   { label: "Advanced Analytics", value: "Tab4" },
// ];

// //Industry counts
// const INDUSTRY_NUMBERS = [
//   { count: "5+", label: "Countries" },
//   { count: "2000+", label: "Compressors Tracked" },
//   { count: "30+", label: "OEM/Service Partners" },
// ];

//Partners section.
// const PARTNERS = [];

function Home() {
  let navigate = useNavigate();
  const [isPaneOpen, setIsPaneOpen] = useState(false);
  const [isCompatibility, setIsCompatibility] = useState(false);

  // const tabData = {
  //   Tab1: {
  //     Description:
  //       "Real-time energy tracking and optimization recommendations.",
  //     ImageName: featuesTab2,
  //   },
  //   Tab2: {
  //     Description: "AI-powered failure prediction and maintenance scheduling.",
  //     ImageName: featuesTab1,
  //   },
  //   Tab3: {
  //     Description: "Instant notifications for critical system events.",
  //     ImageName: featuesTab3,
  //   },
  //   Tab4: {
  //     Description: "Comprehensive reporting and data visualization.",
  //     ImageName: featuesTab4,
  //   },
  //   // Tab5: {
  //   //   Description: "Manage multiple locations and OEM brands.",
  //   //   ImageName: featuesTab5,
  //   // },
  // };

  // const [tabValue, setTabValue] = useState();
  // const [tabImage, setTabImage] = useState();
  // const [currentTabId, setCurrentTabId] = useState();
  const location = useLocation();
  const homePageRefs = {
    home: useRef(),
    goal: useRef(),
    help: useRef(),
    tradition: useRef(),
    partner: useRef(),
    platform: useRef(),
    works: useRef(),
    solutions: useRef(),
  };

  useEffect(() => {
    let ref = homePageRefs[location.state?.scrollTo];
    if (ref && ref.current) {
      const y =
        ref.current.getBoundingClientRect().top + window.pageYOffset - 150;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
    //eslint-disable-next-line
  }, [location]);

  function sendEmail(event) {
      if(!isCompatibility) {
        return;
      }
      
      const serviceId = "service_7u372z3";
      const templateId = "template_rfmfk7v";
      const userKey = process.env.REACT_APP_EMAILJS_API_KEY;

      event.preventDefault();
      const formData = new FormData(event.target);
      formData.append("to_name", "Sales");

      emailjs.sendForm(serviceId, templateId, event.target, userKey).then(
        (result) => {
          document.getElementById("myForm").reset();
          // setState({ isPaneOpen: false });
          setIsPaneOpen(false)
        },
        (error) => {
        console.log(error.text);
        document.getElementById("myForm").reset();
        // setState({ isPaneOpen: false });
        setIsPaneOpen(false);
      }
    );
  }

  // const getFeatures = (currentTab) => {
  //   setCurrentTabId(currentTab);
  //   setTabValue(tabData[currentTab].Description);
  //   setTabImage(tabData[currentTab].ImageName);
  // };

  // const setFeatures = (event) => {
  //   let currentTab;
  //   if (event !== undefined) {
  //     currentTab = event.target.value;
  //   } else {
  //     currentTab = "Tab1";
  //   }

  //   setCurrentTabId(currentTab);
  //   setTabValue(tabData[currentTab].Description);
  //   setTabImage(tabData[currentTab].ImageName);
  // };

  // useEffect(() => {
  //   getFeatures("Tab1");
  //   //eslint-disable-next-line
  // }, []);

  return (
    <React.Fragment>
      <Header />

      <div
        className="container-fluid homebanner-bg"
        style={{ height: "90vh" }}
        ref={homePageRefs.home}
      >
        <div className="home-banner-content-container">
          <div className="home-banner-contents-banner-text-container">
            <div className="home-banner-contents-text-container">
              <span className="home-banner-contents-header-text home-banner-contents-header-text-radius">
                Smarter Compressed Air.
              </span>
              <span className="home-banner-contents-header-text home-banner-contents-header-text-yellow">
                Cleaner Energy.
              </span>
              <span className="home-banner-contents-header-text">
                Measurable Carbon Savings.
              </span>
              <span className="home-banner-contents-info-text home-banner-contents-info-first-text">
                Kompress.ai, a product of Utvyakta Solutions helps industries save energy, reduce emissions, and
                keep compressors running at their best with real-time insights
                and AI-driven intelligence.
              </span>
              {/* <span className="home-banner-contents-info-text">
                Every compressor. Every kilowatt. Every emission. Kompress.ai
                connects it all into one intelligent view so you can see where
                energy is lost, recover efficiency, and drive your operations
                toward a cleaner, smarter future.
              </span> */}
              <span className="home-banner-contents-info-text">
                Every compressor. Every kilowatt. Every emission. Kompress.ai turns data into efficiency, sustainability, and reliability.
              </span>
              <div className="home-banner-contents-button-container">
                {/* <button className="home-banner-contents-button home-banner-button-solution">
              Request Demo
            </button> */}
                <button
                  onClick={() => {
                    var a = document.getElementsByClassName("active-link");
                    a[0].click();
                  }}
                  className="home-banner-contents-button home-banner-button-solution home-banner-button-solution-yellow-banner"
                >
                  Request a Demo
                </button>
                <button
                  onClick={() =>
                    navigate("/casestudies", {
                      state: { scrollTo: "caseStudyBanner" },
                    })
                  }
                  className="home-banner-contents-button home-banner-button-solution"
                >
                  See How You Save Energy
                </button>
              </div>
            </div>
          </div>
          <div className="home-banner-dashboard-img-container">
            <img
              alt=""
              className="home-banner-dashboard-img"
              src={require("./images/home-banner-bg.jpg")}
            />
          </div>
        </div>
        {/* <div className="container">
          <div className="row">
            <div
              className="col-md-6 col-sm-6"
              style={{ "background-color": "#3B0099", paddingBottom: "12px" }}
            >
              <div className="row">
                <div className="col-7">
                  <h1
                    className="heading mobile-heading"
                    style={{ padding: "50px 40px 30px 40px" }}
                  >
                    Enabling intelligence for air compressors
                  </h1>
                  <button
                    onClick={() => navigate("/solutions")}
                    className="clear-btn mobile-clear-btn"
                    style={{ marginLeft: "40px" }}
                  >
                    Our Solution
                  </button>
                </div>
                <div className="col-5 padding-50">
                  <img alt="preview"
                    src={require("./images/banner-right-img.png")}
                    className="img-responsive"
                  />
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </div>
      {/* 
      <div className="" ref={homePageRefs.goal}>
        <div className="row row-reverse home-goal-container">
          <div className="col-md-5 col-sm-12 padding-50 mobile-left-padding">
            <h1
              className="heading white-heading mobile-only home-goal-heading-h1"
              style={{ padding: "10px 40px 10px 40px" }}
            >
              Aligned to UN SDG Goal of industries, innovation & infrastructure
            </h1>
            <img
              src={require("./images/home_section_2.png")}
              width="80px" alt="preview"
              style={{ marginLeft: "200px" }}
            />
            <img src={require("./images/home_section_1.png")} width="300px" alt="preview"/>
          </div>
          <div className="col-md-6 col-sm-12">
            <h1
              className="heading white-heading desktop-only"
              style={{ padding: "50px 40px 30px 40px" }}
            >
              Aligned to UN SDG Goal of industries, innovation & infrastructure
            </h1>
            <p className="para mobile-top-10" style={{ fontSize: "1.1em" }}>
              We are an Industrial Internet of Things (IIoT) solutions provider
              specializing in enabling intelligence of air compressors. Our
              vision is to reduce carbon emissions by 15% through smart
              technology interventions that reduce energy consumption and
              maintenance cost for industrial machines. Talk to us to understand
              how real-time monitoring of your compressors can save costs for
              you and concerns for the planet.
            </p>
            
            <button
              onClick={() => navigate('/aboutus', { state: { scrollTo: 'about'} })}
              className="clear-btn pink-btn mobile-btn"
              style={{ marginTop: "15px" }}
            >
              Get to know us
            </button>
           
          </div>
        </div>
      </div> */}

      <div className="container-fluid grey-bg" style={{ display: "none" }}>
        <div className="">
          <div className="col-12 text-center brand-heading">
            Brands who trust us
          </div>
          <div className="col-12 text-center">
            <div>
              <div className="brand-logos">
                {/* <img src={ require('./images/logo_1.png') } /> */}
                <img src={require("./images/logo_2.svg")} alt="preview" />
                {/* <img src={ require('./images/logo_3.png') } /> */}
                <img src={require("./images/logo_4.png")} alt="preview" />
                <img src={require("./images/logo_5.png")} alt="preview" />
                <img src={require("./images/logo_6.png")} alt="preview" />
                <img src={require("./images/logo_7.png")} alt="preview" />
              </div>
              <div className="brand-logos">
                {/* <img src={ require('./images/logo_8.png') } />
                      <img src={ require('./images/logo_9.png') } /> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div ref={homePageRefs.platform} className="container-fluid">
        <div className="home-platform-container">
          <div className="d-flex flex-column justify-content-center align-items-center">
            <span className="home-platform-title-text white-heading">
              One Platform - For Energy, Carbon & Reliability
            </span>
            <span className="home-platform-sub-title-text">
              Whether you're an OEM, service company, or end user, Kompress.ai
              turns your compressed air network into a connected ecosystem that
              saves energy and boosts uptime.
            </span>
          </div>
          <div className="d-flex home-platform-card-contents-container">
            {HOME_PLATFORM_CONTENT.map((data) => (
              <div className="home-platform-card-container d-flex flex-column">
                <div>
                  {/* <img className="home-help-card-header-img" src={data.img} alt=""/> */}
                </div>
                <div className="home-help-card-content-container">
                  <div className="d-flex flex-column home-help-card-header">
                    <span className="home-platform-card-title">
                      {data.title}
                    </span>
                    <span className="home-platform-card-title-info">
                      {data.info}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="home-platform-button-group">
            <button
              onClick={() =>
                navigate("/intelligence", {
                  state: { scrollTo: "solutionbanner" },
                })
              }
              className="home-banner-contents-button home-banner-button-solution home-banner-button-solution-yellow"
            >
              Explore More
            </button>
          </div>
          {/* <div className="row">
            <div className="col-12 text-center brand-heading">Why Utvyakta</div>

            <div className="col-12">
              <div className="row why-utv-panel-column">
                <div className="col col-md-4 col-sm-12 text-center why-utv-panel">
                  <img src={require("./images/why_utv_1.png")} alt="preview"/>
                  <h2 className="sub-heading">
                    Deep understanding of air compressor performance &amp;
                    maintenance
                  </h2>
                </div>
                <div className="col col-md-4 col-sm-12 text-center why-utv-panel">
                  <img src={require("./images/why_utv_2.png")} alt="preview"/>
                  <h2 className="sub-heading">
                    Over 80% market share of key compressor OEMs in India
                  </h2>
                </div>
                <div className="col col-md-4 col-sm-12 text-center why-utv-panel">
                  <img src={require("./images/why_utv_3.png")} alt="preview" />
                  <h2 className="sub-heading">
                    Productivity &amp; energy efficiency through data and
                    real-time analytics
                  </h2>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>

      <div ref={homePageRefs.works} className="home-works-parent-container">
        <div className="home-works-header">
          <span className="home-works-header-title">
            Works with Any Compressor. Any Controller. Any Site.
          </span>
          <span className="home-works-header-sub-title">
            Kompress.ai connects to multiple OEM controllers and legacy systems
            seamlessly.
          </span>
        </div>
        <div className="home-works-content-container">
          <div className="home-works-content-left-container">
            {/* <span className="home-works-left-header">
              Kompress.ai connects to any compressor, across brands and
              generations. It works with modern controllers or legacy machines
              using smart sensors. The platform also links dryers, flow meters,
              and energy meters, creating a complete view of your compressed air
              system.
            </span> */}
            <span className="home-works-left-header">
              Kompress.ai connects compressors, dryers, energy meters and flow meters of any brand or age into one intelligent system.
            </span>
            <ul className="home-works-list-container">
              <li>Vendor-neutral integration</li>
              <li>Data normalization across models and ages</li>
              <li>Multi-site, multi-compressor fleet visibility</li>
              <li>Secure cloud storage and analytics</li>
            </ul>
            <div className="home-works-list-btn-grp">
              <button
              onClick={() => setIsPaneOpen(true)}
              className="home-works-list-check-btn">
                Check Compatibility
              </button>
              <a
                href="mailto:field@utvyakta.com"
                className="home-works-list-team-btn"
              >
                Talk to Our Integration Team
              </a>
            </div>
          </div>
          <div className="home-works-content-right-container">
            <img src={require("./images/multibrand.png")} alt="" />
          </div>
        </div>
      </div>

      <div
        ref={homePageRefs.solutions}
        className="container-fluid"
        style={{ background: "#f9f9f9" }}
      >
        <div className="home-platform-container">
          <div className="d-flex flex-column justify-content-center align-items-center">
            <span className="home-platform-title-text white-heading">
              Empower Your Service & OEM Business.
            </span>
            <span className="home-platform-sub-title-text">
              Transform from reactive support to proactive intelligence.
            </span>
          </div>
          <div className="d-flex home-platform-card-contents-container">
            {HOME_EMPOWER_CONTENT.map((data) => (
              <div className="home-platform-card-container d-flex flex-column">
                <div>
                  {/* <img className="home-help-card-header-img" src={data.img} alt=""/> */}
                </div>
                <div className="home-help-card-content-container">
                  <div className="d-flex flex-column home-help-card-header">
                    <span className="home-platform-card-title">
                      {data.title}
                    </span>
                    <span className="home-platform-card-title-info">
                      {data.info}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <SlidingPane
            className="sliding-panel"
            overlayClassName="some-custom-overlay-class"
            isOpen={isPaneOpen}
            title="Hey, it is optional pane title.  I can be React component too."
            subtitle="Optional subtitle."
            width="500px"
            onRequestClose={() => {
              // triggered on "<" on left top click or on outside click
              // setState({ isPaneOpen: false });
              setIsPaneOpen(false)
            }}
          >
            <h2
              className="sub-heading"
              style={{ paddingTop: "50px", paddingBottom: "10px", fontWeight: "bold" }}
            >
              Check Compatibility
            </h2>

            <p>Fill out this form. We will get back to you!</p>
          
            {/* <span
              class="fa fa-close close-icon"
              onClick={() => setIsPaneOpen(true)}
            ></span> */}
            <form onSubmit={sendEmail} id="myForm">
              <div className="form-group">
                <input
                  type="hidden"
                  className="form-control"
                  name="to_name"
                  value="Sales"
                />
              </div>
          
              <div className="form-group">
                <label for="exampleInputEmail1">
                  Compressor Brand / OEM <span className="mandatory">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="firstname"
                  id="validationCustom05"
                  required
                />
                <div className="invalid-feedback">Please provide a valid zip.</div>
              </div>
          
              <div className="form-group">
                <label for="exampleInputEmail1">
                  Compressor Model / Series <span className="mandatory">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="lastname"
                  id="exampleInputEmail1"
                  required
                />
              </div>
          
              <div className="form-group">
                <label for="exampleInputEmail1">
                  Controller Model / Type <span className="mandatory">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="company"
                  id="exampleInputEmail1"
                  required
                />
              </div>

              <div className="form-group">
                <label for="exampleInputEmail1">
                  Number of Compressors <span className="mandatory">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="company"
                  id="exampleInputEmail1"
                  required
                />
              </div>
          
              <div className="form-group">
                <label for="exampleInputEmail1">
                  Connection Preference (Modbus RTU/TCP, Others, NA) <span className="mandatory">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="workemail"
                  id="exampleInputEmail1"
                  required
                />
              </div>
          
              <div className="form-group">
                <label for="exampleInputEmail1">
                  Power Rating (kW) <span className="mandatory">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="phonenumber"
                  id="exampleInputEmail1"
                  required
                />
              </div>

              <div className="form-group">
                <label for="exampleInputEmail1">
                  Your Name<span className="mandatory">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="phonenumber"
                  id="exampleInputEmail1"
                  required
                />
              </div>


              <div className="form-group">
                <label for="exampleInputEmail1">
                  Email Address<span className="mandatory">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="phonenumber"
                  id="exampleInputEmail1"
                  required
                />
              </div>

              <div className="form-group">
                <label for="exampleInputEmail1">
                  Company Name <span className="mandatory">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="phonenumber"
                  id="exampleInputEmail1"
                  required
                />
              </div>

              <div style={{display: "flex", gap: "1rem", alignItems: "center", justifyContent: ""}}>
                <input type="checkbox" checked={isCompatibility} onChange={(event) => {
                  console.log(event.target.checked);
                  
                  setIsCompatibility(event.target.checked)}}/>
                <span>I agree to receive communications from Kompress.ai about compatibility and setup options *</span>
              </div>
          
              <button
                type="submit"
                className="clear-btn pink-btn schedulebtn"
                style={{ marginTop: "15px", width: "300px" }}
              >
                Submit 
              </button>
            </form>
          </SlidingPane>
          {/* <div className="row">
            <div className="col-12 text-center brand-heading">Why Utvyakta</div>

            <div className="col-12">
              <div className="row why-utv-panel-column">
                <div className="col col-md-4 col-sm-12 text-center why-utv-panel">
                  <img src={require("./images/why_utv_1.png")} alt="preview"/>
                  <h2 className="sub-heading">
                    Deep understanding of air compressor performance &amp;
                    maintenance
                  </h2>
                </div>
                <div className="col col-md-4 col-sm-12 text-center why-utv-panel">
                  <img src={require("./images/why_utv_2.png")} alt="preview"/>
                  <h2 className="sub-heading">
                    Over 80% market share of key compressor OEMs in India
                  </h2>
                </div>
                <div className="col col-md-4 col-sm-12 text-center why-utv-panel">
                  <img src={require("./images/why_utv_3.png")} alt="preview" />
                  <h2 className="sub-heading">
                    Productivity &amp; energy efficiency through data and
                    real-time analytics
                  </h2>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>

      {/* <div ref={homePageRefs.help} className="container-fluid why-utv-container grey-bg">
        <div className="home-help-container">
          <div className="d-flex flex-column justify-content-center align-items-center">
            <span className="home-help-title-text white-heading">Who We Help</span>
            <span className="home-help-sub-title-text">Tailored solutions for every stakeholder in the compressed air ecosystem</span>
          </div>
          <div className="d-flex home-help-card-contents-container">
              {HOME_HELP_CONTENT.map((data) => <div className="card home-help-card-container d-flex flex-column">
                <div>
                  <img className="home-help-card-header-img" src={data.img} alt=""/>
                </div>
                <div className="home-help-card-content-container">
                <div className="d-flex flex-column home-help-card-header">
                  <span className="home-help-card-title">{data.title}</span>
                  <span className="home-help-card-title-info">{data.info}</span>
                </div>
                <div className="d-flex flex-column home-help-card-info-text-container">
                  {
                    data.contents.map((info) => <div className="home-help-card-info-text">{ Icons(16, 16, "green").Tick()}{info}</div>)
                  }
                </div>
                </div>
              </div>)}
          </div>

          <div className="row">
            <div className="col-12 text-center brand-heading">Why Utvyakta</div>

            <div className="col-12">
              <div className="row why-utv-panel-column">
                <div className="col col-md-4 col-sm-12 text-center why-utv-panel">
                  <img src={require("./images/why_utv_1.png")} alt="preview"/>
                  <h2 className="sub-heading">
                    Deep understanding of air compressor performance &amp;
                    maintenance
                  </h2>
                </div>
                <div className="col col-md-4 col-sm-12 text-center why-utv-panel">
                  <img src={require("./images/why_utv_2.png")} alt="preview"/>
                  <h2 className="sub-heading">
                    Over 80% market share of key compressor OEMs in India
                  </h2>
                </div>
                <div className="col col-md-4 col-sm-12 text-center why-utv-panel">
                  <img src={require("./images/why_utv_3.png")} alt="preview" />
                  <h2 className="sub-heading">
                    Productivity &amp; energy efficiency through data and
                    real-time analytics
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {/* <div ref={homePageRefs.tradition} className="container-fluid comparision_section">
        <div className="comaprision-table">
          Traditional Vs Smart Compressors
        </div>
        <img alt="preview"
          src={require("./images/desktop_comparision_img.png")}
          className="desktop-only"
        />
        <img alt="preview "
          src={require("./images/mobile_comparision_img.png")}
          className="mobile-only"
        />
      </div> */}

      {/* <div className="container-fluid light-green-bg home-features-container">
          <div className="home-features-left-container">
            <div className="home-features-left-side-img">
              <img src={require("./images/kompressai.png")} alt=""/>
              <span>Everything you need to optimize your compressed air systems</span>
            </div>
            <div className="home-features-ulist-container">
              <ul className="home-features-list-container">
                {FEATURES_TABS.map((data) => {
                  return <li
                  className={`home-features-list ${currentTabId === data.value ? "home-features-list-active" : ""}`}
                  onClick={() => getFeatures(data.value)}
                  >
                    {data.label}
                  </li>
                })
                }
              </ul>
              <div className="home-featrures-select-container">
              <select
              className="home-featrures-select"
              onChange={setFeatures}
              >
                {FEATURES_TABS.map((data) => {
                  return <option
                  value={data.value}
                  >
                    {data.label}
                  </option>
                })
                }
              </select>
              </div>
            </div>
            <div className="home-features-buttons-container">
              <div className="home-features-button" onClick={() => navigate('/solutions', { state: { scrollTo: 'energyCost'} })}>Calculate Energy Savings</div>
              <div className="home-features-button" onClick={() => navigate('/solutions', { state: { scrollTo: 'architechture'} })}>Solution Architecture</div>
            </div>
          </div>
          <div className="home-features-right-container">
              <span>{tabValue}</span>
              {tabImage && <img  src={tabImage} alt="preview"/>}
          </div>
      </div> */}

      {/* <div ref={homePageRefs.partner} className="container-fluid home-industry-section">
        <div className="d-flex flex-column home-industry-section-container">
          <div className="d-flex flex-column home-industry-section-header-content-container">
            <span className="home-industry-section-header-text white-heading">Kompress.ai in Numbers</span>
            <span className="home-industry-section-header-info">Trusted by industry leaders worldwide</span>
          </div>
          <div className="d-flex home-industry-section-numbers-container">
            {
              INDUSTRY_NUMBERS.map((data) => {
                return (
                  <div className="d-flex flex-column home-industry-section-details-container">
                    <span className="home-industry-number-text">{data.count}</span>
                    <span className="home-industry-number-text-label">{data.label}</span>
                  </div>
                )
              })
            }
          </div>
          <div className="d-flex flex-column home-industry-partner-container">
            <span className="home-industry-partner-header-text">Trusted by Leading Partners</span>
            <div className="d-flex home-industry-partner-card-container">
              {PARTNERS.map((data) => <div className="home-industry-partner-card">{data}</div>)}
            </div>
          </div>
          <div className="d-flex flex-column home-industry-contact-container">
            <span className="home-industry-contact-text">"Let's make compressed air intelligent"</span>
          </div>
        </div>
      </div> */}

      {/* <div className="container-fluid why-utv-container">
        <div className="">
          <div className="row">
            <div className="col-12 text-center brand-heading">In the news</div>

            <div className="col-md-12">
              <div className="row panel">
                <div className="col col-md-3 text-center why-utv-panel utv-card">
                  <img src={require("./images/news_1.png")} alt="preview"/>
                  <p className="para">
                    Cloudvidia Invests in Utvyakta for Software and Platforms to
                    Expand Reach of Industry 4.0
                  </p>
                  <div className="separator"></div>
                  <div className="readmore-panel">
                    <span className="read-panel-left">
                      <a
                        href="https://www.prnewswire.com/news-releases/cloudvidia-invests-in-utvyakta-for-software-and-platforms-to-expand-reach-of-industry-4-0--301219927.html"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Read more
                      </a>
                    </span>
                    <span className="read-panel-right">
                      <a
                        href="https://www.prnewswire.com/news-releases/cloudvidia-invests-in-utvyakta-for-software-and-platforms-to-expand-reach-of-industry-4-0--301219927.html"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img alt="preview"
                          src={require("./images/link.png")}
                          style={{ width: "45px" }}
                        />
                      </a>
                    </span>
                  </div>
                </div>
                <div className="col offset-md-1 offset-sm-0 col-md-3 text-center why-utv-panel utv-card">
                  <img src={require("./images/news_2.png")} alt="preview"/>
                  <p className="para">Utvyakta sets up base in sweden</p>
                  <div className="separator"></div>
                  <div className="readmore-panel">
                    <span className="read-panel-left">
                      <a
                        href="https://press.investstockholm.com/posts/pressreleases/indias-utvyakta-solutions-picks-stockholm-as"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Read more
                      </a>
                    </span>
                    <span className="read-panel-right">
                      <a
                        href="https://press.investstockholm.com/posts/pressreleases/indias-utvyakta-solutions-picks-stockholm-as"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          alt=""
                          src={require("./images/link.png")}
                          style={{ width: "45px" }}
                        />
                      </a>
                    </span>
                  </div>
                </div>
                <div className="col offset-md-1 offset-sm-0 col-md-3 text-center why-utv-panel utv-card">
                  <img src={require("./images/news_3.png")} alt="preview"/>
                  <p className="para">
                    Utvyakta emerges as a finalist in RTX innovation challenge
                  </p>
                  <div className="separator"></div>
                  <div className="readmore-panel">
                    <span className="read-panel-left">
                      <a
                        href="https://economictimes.indiatimes.com/small-biz/startups/newsbuzz/t-hub-raytheon-technologies-select-three-startups-as-finalists-for-rtx-innovation-challenge/articleshow/77906609.cms?from=mdr"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Read more
                      </a>
                    </span>
                    <span className="read-panel-right">
                      <a
                        href="https://economictimes.indiatimes.com/small-biz/startups/newsbuzz/t-hub-raytheon-technologies-select-three-startups-as-finalists-for-rtx-innovation-challenge/articleshow/77906609.cms?from=mdr"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img alt="preview"
                          src={require("./images/link.png")}
                          style={{ width: "45px" }}
                        />
                      </a>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      <Footer pageRefs={homePageRefs} />
    </React.Fragment>
  );
}

export default Home;
